import { render, staticRenderFns } from "./AISettings.vue?vue&type=template&id=040f3644&scoped=true"
import script from "./AISettings.vue?vue&type=script&lang=js"
export * from "./AISettings.vue?vue&type=script&lang=js"
import style0 from "./AISettings.vue?vue&type=style&index=0&id=040f3644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f3644",
  null
  
)

export default component.exports